<template>
  <div class="contract">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="col-lg-3">
              <ContractContactBlockComponent :registration="registration" />
            </div>

            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-6">
                  <ContractApprenticeBlockComponent :registration="registration" />
                </div>

                <div class="col-lg-6">
                  <ContractCompanyBlockComponent :registration="registration" />

                  <ContractTrainingBlockComponent :registration="registration" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <ActionsBlock :actions="actions" />
          <RegistrationStepsComponent :steps="steps" />
          <ContractCommentBlockComponent />
          <ContractHistoryBlockComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractContactBlockComponent from "@/components/registration/contract/ContractContactBlockComponent.vue";
import ContractApprenticeBlockComponent from "@/components/registration/contract/ContractApprenticeBlockComponent.vue";
import ContractCompanyBlockComponent from "@/components/registration/contract/ContractCompanyBlockComponent.vue";
import ContractTrainingBlockComponent from "@/components/registration/contract/ContractTrainingBlockComponent.vue";
import ActionsBlock from "@/components/blocks/ActionsBlock.vue";
import ContractHistoryBlockComponent from "@/components/registration/contract/ContractHistoryBlockComponent.vue";
import ContractCommentBlockComponent from "@/components/registration/contract/ContractCommentBlockComponent.vue";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import { registrationManager } from "@/services/registration/registration-manager";
import RegistrationStepsComponent from "@/components/registration/RegistrationStepsComponent.vue";

export default {
  name: "ContractSheetView",
  components: {
    RegistrationStepsComponent,
    ContractCommentBlockComponent,
    ContractHistoryBlockComponent,
    ActionsBlock,
    ContractTrainingBlockComponent,
    ContractCompanyBlockComponent,
    ContractApprenticeBlockComponent,
    ContractContactBlockComponent,
  },
  data() {
    return {
      registration: {},
      steps: [],
      actions: [
        {
          actionType: "button",
          icon: "check ",
          type: "primary",
          action: "registrationValidation",
          translation: "Valider l'inscription",
          cfaStyle: true,
          registrationStep: {
            id: 7,
          },
        },
        {
          actionType: "button",
          icon: "triangle-exclamation",
          type: "warning",
          action: "declareEvent",
          translation: "Déclarer un évènement",
          cfaStyle: false,
          registrationStep: {
            id: 8,
          },
        },
        {
          actionType: "button",
          icon: "upload",
          type: "danger",
          action: "cancel",
          translation: "Annuler",
          cfaStyle: false,
          registrationStep: {
            id: 9,
          },
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.closeSideBar();
    this.init();
  },
  methods: {
    init() {
      this.setAppLoading(false);
      this.getRegistration();
    },

    getRegistration() {
      registrationManager.getRegistration(this.$route.params.id).then((res) => {
        this.registration = res.registration;
        this.steps = res.steps;
        this.addRegistrationButton();
      });
    },

    addRegistrationButton() {
      if (this.registration?.registrationGroup?.group?.cryptedId) {
        this.actions.push({
          actionType: "router",
          icon: "eye",
          type: "primary",
          action: "TrainingPreRegistration",
          params: {
            group: this.registration?.registrationGroup?.group?.cryptedId,
            tab: 0,
            registration: this.registration.cryptedId,
          },
          translation: "Voir la fiche de pré-inscription",
          cfaStyle: false,
        });
      }
    },

    ...mapActions(useMainStore, {
      setAppLoading: "setAppLoading",
      closeSideBar: "closeSideBar",
    }),
  },
};
</script>

<style lang="scss" scoped>
.history {
  font-size: 13px;
}
</style>
